import {
  Text,
  UseDisclosureProps,
} from '@chakra-ui/react';
import { RModal } from 'components';
import { IconLockRg } from 'icons';

const BlockPaidRacesModal = ({
  isOpen = false,
  onClose = () => null,
}: UseDisclosureProps) => {
  return (
    <RModal
      isOpen={isOpen}
      onClose={onClose}
      modalVariant="red"
      title="Entry Restricted"
      size="2xl"
      isCentered
      icon={<IconLockRg />}
    >
      <Text
        fontSize={{ base: '14px', md: '18px' }}
        lineHeight={{ base: '18px', md: '24px' }}
        fontWeight={600}
        color="white.80"
      >
        Our full gaming services are not available in your region due to legal limits, but you can still enjoy other parts of our platform as we work to expand access.
      </Text>
    </RModal>
  );
};

export default BlockPaidRacesModal;
